import script from "./kpiTable.vue?vue&type=script&setup=true&lang=js"
export * from "./kpiTable.vue?vue&type=script&setup=true&lang=js"

import "./kpiTable.vue?vue&type=style&index=0&id=6c11ccf3&lang=css"

const __exports__ = script;

export default __exports__